module.exports = __webpack_public_path__ + "static/media/liveroom-setting-vip.c6080659.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/liveroomSetting/liveroom-setting-vip.png
// module id = 1979
// module chunks = 6